import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import {
  getSubscriptionProjectTableColumn,
  getFrequencyTableColumn,
  getSubjectTableColumn,
  getDataScopeTableColumn,
  getNotifyTypeTableColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getEnabledTableColumn(),
      getSubscriptionProjectTableColumn(),
      getFrequencyTableColumn(),
      getSubjectTableColumn(),
      getDataScopeTableColumn({ vm: this }),
      getNotifyTypeTableColumn(),
      getTimeTableColumn({ field: 'created_at', title: this.$t('common.createdAt') }),
    ]
  },
}
